import React from "react";
import AdminLayout from "../admin/AdminLayout";
import { Link } from "react-router-dom"

const AdminDashboard = () => {
  return (
    <AdminLayout>

      <div className="dashboard-cards">

        <Link to="/admin/birthday"><div className="card">Birthday</div></Link>
        <Link to="/admin/slider"><div className="card">Slider</div></Link>
        <Link to="/admin/academics"><div className="card">Acadmics</div></Link>
        <Link to="/admin/student-work"><div className="card">Student Work</div></Link>
        <Link to="/admin/notice"><div className="card">Notice</div></Link>
        <Link to="/admin/gallery-album"><div className="card">Gallery</div></Link>
        <Link to="/admin/galleryAwards"><div className="card">Gallery & Awards</div></Link>
        <Link to="/admin/event"><div className="card">Event</div></Link>
        <Link to="/admin/news"><div className="card">News</div></Link>
        <Link to="/admin/uploadDocuments"><div className="card">Upload Homeworks</div></Link>
        <Link to="/admin/cbse"><div className="card">CBSE Document</div></Link>
        <Link to="/admin/adminstudent-tc"><div className="card">Student TC</div></Link>
        <Link to="/admin/admin-tour"><div className="card">Virtual Tour</div></Link>
        <Link to="/admin/admin-online"><div className="card">Online Registration Data</div></Link>
        <Link to="/admin/admin-holiday"><div className="card">Holiday</div></Link>
        <Link to="/admin/admin-class"><div className="card">Class Monitor</div></Link>
        <Link to="/admin/admin-studentcouncil"><div className="card">Student Council</div></Link>
        <Link to="/admin/admin-house"><div className="card">School House</div></Link>
        <Link to="/admin/alumni"><div className="card">Alumani</div></Link>
        <Link to="/admin/password"><div className="card">Change Password</div></Link>

      </div>

    </AdminLayout>
  );
};

export default AdminDashboard;